import { render, staticRenderFns } from "./keepAliveMO.vue?vue&type=template&id=0c670ed8&"
import script from "./keepAliveMO.vue?vue&type=script&lang=js&"
export * from "./keepAliveMO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports